import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
// import "./PackageDetail.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const PokharaPackage = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO BANNER */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage:
            "url('/Images/tour/pokhara-banner.jpg')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Pokhara Scenic Escape</h1>

            <p className="hero-subtitle">
              3 Nights / 4 Days • Pokhara Sightseeing Package
            </p>

            <div className="hero-price">
              Starting From <span>₹21,999</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + FORM */}
        <Row className="mb-4">

          {/* LEFT SLIDER */}
          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/pokhara-banner.jpg" alt="" />
                <img src="/Images/tour/Pokhara.jpg" alt="" />
                <img src="/Images/tour/pokhara2.jpeg" alt="" />
              </Slider>
            </div>
          </Col>

          {/* RIGHT FORM */}
          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹21,999</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>
        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Pokhara Scenic Escape</h1>
              <p>3 Nights / 4 Days • Pokhara Sightseeing</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Phewa Lake Boating</Col>
                <Col md={6}>✔ Sarangkot Sunrise View</Col>
                <Col md={6}>✔ Davis Falls Visit</Col>
                <Col md={6}>✔ World Peace Pagoda</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Experience the natural beauty of Nepal with Pokhara Tour
                Package. Enjoy serene lakes, Himalayan views, adventure
                activities and peaceful spiritual attractions.
              </p>
            </div>

            {/* Itinerary */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>Day 1 – Arrival Pokhara</Accordion.Header>
                  <Accordion.Body>
                    Arrival, hotel check-in and evening leisure at Lakeside Market.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>Day 2 – Pokhara Sightseeing</Accordion.Header>
                  <Accordion.Body>
                    Visit Davis Falls, Gupteshwor Cave, Bindhyabasini Temple
                    and boating at Phewa Lake.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>Day 3 – Sarangkot Sunrise</Accordion.Header>
                  <Accordion.Body>
                    Early morning Sarangkot sunrise view and optional
                    adventure activities like paragliding.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>Day 4 – Departure</Accordion.Header>
                  <Accordion.Body>
                    Breakfast and transfer for onward journey.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* Inclusion / Exclusion */}
            <div className="content-box">
              <Row>

                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul className="inclusion-list">
                    <li>Hotel Accommodation</li>
                    <li>Breakfast & Dinner</li>
                    <li>Airport Transfers</li>
                    <li>Sightseeing Tours</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul className="exclusion-list">
                    <li>Personal Expenses</li>
                    <li>Adventure Activities</li>
                    <li>Insurance</li>
                    <li>Lunch</li>
                  </ul>
                </Col>

              </Row>
            </div>

            {/* Gallery */}
            <div className="content-box">
              <h3>Gallery</h3>

              <Row className="gallery">
                <Col md={4}>
                  <img src="/Images/tour/pokhara-banner.jpg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/Pokhara.jpg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/pokhara2.jpeg" alt="" />
                </Col>
              </Row>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default PokharaPackage;